import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  ReferenceLine,
} from "recharts";

const GrowthChart = ({ data, classOpt, load }) => {
  console.log("GROWTH CHART data returned:", data);

  // Helper function to format month and year as "month year"
  const formatMonthYear = (month, year) => {
    const monthMapping = {
      jan: "Jan",
      feb: "Feb",
      mar: "Mar",
      apr: "Apr",
      may: "May",
      jun: "Jun",
      jul: "Jul",
      aug: "Aug",
      sep: "Sep",
      oct: "Oct",
      nov: "Nov",
      dec: "Dec",
    };
    return `${monthMapping[month]} ${year}`;
  };

  const formattedData = data
    ? Array.isArray(data["annual-growth"])
      ? data["annual-growth"].flatMap((yearData) => {
          const { year_no, ...monthReturns } = yearData;
          // Filter out non-monthly keys
          return Object.keys(monthReturns)
            .filter(
              (key) =>
                ![
                  "q1_growth_amount",
                  "q2_growth_amount",
                  "q3_growth_amount",
                  "q4_growth_amount",
                  "ytd_growth_amount",
                ].includes(key)
            )
            .map((key) => {
              const [month] = key.split("_"); // Extract the month from the key
              const value = parseFloat(monthReturns[key]); // Parse value as a number
              return {
                date: formatMonthYear(month, year_no), // Format date as "Month Year"
                value, // Numeric value for the chart
              };
            });
        })
      : Object.keys(data["annual-growth"]) // Handle the case where it's an object
          .filter(
            (key) =>
              ![
                "q1_growth_amount",
                "q2_growth_amount",
                "q3_growth_amount",
                "q4_growth_amount",
                "ytd_growth_amount",
                "year_no",
              ].includes(key)
          )
          .map((key) => {
            const [month] = key.split("_"); // Extract the month from the key
            const value = parseFloat(data["annual-growth"][key]); // Parse value as a number
            const year_no = data["annual-growth"].year_no; // Extract year number
            return {
              date: formatMonthYear(month, year_no), // Format date as "Month Year"
              value, // Numeric value for the chart
            };
          })
    : null;

  // Only include valid data points
  const validData = formattedData
    ? formattedData.filter((entry) => !isNaN(entry.value) && entry.value > 0)
    : [];

  const values = validData.map((d) => d.value);
  // const minY = Math.min(...values) * 0.98;
  // const maxY = Math.max(...values) * 1.02;

  return (
    <div className="main-padding">
      <div className="main-margin">
        {/* <div className="monthly-total-return-img-wrapper">
          <h1 className="sub-header">
            Growth of $100k<sup className="small-sup">1</sup>
            <sup className="small-sup">,</sup>
            <sup className="small-sup">3</sup>
          </h1>
        </div> */}
        <div className="chart-wrapper w-full h-full p-4 shadow-lg">
          <ResponsiveContainer width="100%" height={300}>
            <LineChart
              data={validData}
              margin={{
                top: 5,
                right: 30,
                left: 40,
                bottom: 30,
              }}
            >
              <ReferenceLine y={100000} stroke="#000" strokeWidth={3} />
              <CartesianGrid horizontal={true} vertical={false} />
              <XAxis dataKey="date" tick={{ angle: -45, dy: 20 }} />
              <YAxis
                // label={{
                //   value: "NAV", // Text to display
                //   angle: -90, // Rotate the label for vertical alignment
                //   position: "insideLeft", // Position relative to the axis
                //   offset: -12,
                //   style: { textAnchor: "middle" }, // Optional: center the text
                // }}
                tickFormatter={(value) => `$${(value / 1000).toFixed(0)}k`}
                domain={["dataMin", "dataMax"]}
                tickMargin={10}
                // tickFormatter={(value) => `$${value.toLocaleString()}`}
                // domain={[90000, 220000]} // Start at 9.75 and end at 10.75
                // domain={[minY, maxY]}
                ticks={[90000, 100000, 110000, 120000, 130000, 140000]}
              />
              {/* <Tooltip formatter={(value) => `$${value.toFixed(2)}`} /> */}
              <Tooltip
                formatter={(value) => [`$${(value / 1000).toFixed(0)}K`]} // only value, no "value" label
                labelFormatter={(label) => {
                  const [month, year] = label.split(" ");
                  return `${month} '${year.slice(-2)}`; // Example: "May '23"
                }}
                contentStyle={{
                  borderColor: "#c39f5c",
                  borderRadius: "4px",
                  fontWeight: "bold",
                }}
              />

              {/* <Legend /> */}
              <Line
                type="monotone"
                dataKey="value"
                stroke="#c39f5c"
                strokeWidth={3}
                dot={false}
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

export default GrowthChart;
